export default "__VITE_ASSET__ee44a814__"